import { render, staticRenderFns } from "./SolutionComments.vue?vue&type=template&id=493817fe&"
import script from "./SolutionComments.vue?vue&type=script&lang=js&"
export * from "./SolutionComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports